"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migratedWithdrawalGasLimit = exports.hashLowLevelMessage = void 0;
const core_utils_1 = require("@eth-optimism/core-utils");
const ethers_1 = require("ethers");
const hashLowLevelMessage = (message) => {
    return (0, core_utils_1.hashWithdrawal)(message.messageNonce, message.sender, message.target, message.value, message.minGasLimit, message.message);
};
exports.hashLowLevelMessage = hashLowLevelMessage;
const migratedWithdrawalGasLimit = (data) => {
    const dataCost = (0, core_utils_1.calldataCost)(data);
    let minGasLimit = dataCost.add(200000);
    if (minGasLimit.gt(25000000)) {
        minGasLimit = ethers_1.BigNumber.from(25000000);
    }
    return minGasLimit;
};
exports.migratedWithdrawalGasLimit = migratedWithdrawalGasLimit;
//# sourceMappingURL=message-utils.js.map